export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <circle cx="32" cy="32" r="22" stroke="#C9A24B" strokeWidth="2.4" opacity="0.9" />
    <path d="M32 14 L50 32 L32 50 L14 32 Z" stroke="#EFE9DA" strokeWidth="1.7" />
    <circle cx="32" cy="32" r="4.4" fill="#C9A24B" />
    <path d="M32 4 v8 M32 52 v8 M4 32 h8 M52 32 h8" stroke="#C9A24B" strokeWidth="2" opacity="0.7" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="group flex items-center gap-3">
    <LogoMark className="h-9 w-9 transition-transform duration-700 group-hover:rotate-45" />
    <span className="leading-none">
      <span className="block font-display text-lg font-medium tracking-[0.3em] text-ivory">
        ENEXUR
      </span>
      {!compact && (
        <span className="mt-1.5 block font-mono text-[9px] tracking-[0.42em] text-gold/80">
          COMMUNICATION
        </span>
      )}
    </span>
  </span>
);
